import { useState } from 'react'
import './input.scss'

const Input = props => {
	const {
		label,
		value,
		name,
		errors,
		register,
		change,
		autoComplete,
		id,
		disabled = false,
		type,
		blurEvent,
		placeholder = ' ',
		fieldActiveInitial = false,
		onKeyDown,
		testid,
		clases,
		min,
		max,
		required
	} = props

	const [fieldActive, setFieldActive] = useState(fieldActiveInitial)

	const activateField = () => {
		setFieldActive(true)
	}

	const disableFocus = e => {
		if (e.target.value === '') {
			setFieldActive(false)
		}
	}

	const hasError = errors && errors[name]

	const inputClasses = `a-input ${placeholder !== ' ' || fieldActive ? 'active ' : ''}${
		hasError ? 'error ' : ''
	}${disabled ? 'disabled ' : ''}`

	const labelClasses = `a-input-label ${
		placeholder !== ' ' || (typeof value !== 'undefined' && value !== '') || fieldActive
			? 'active '
			: ''
	}${hasError ? 'error ' : ''}`

	// Expresión regular para caracteres alfanuméricos
	const alphaNumericRegex = /^[a-zA-Z0-9]*$/

	const handleKeyDown = e => {
		if (type === 'alphaNumeric') {
			// Validar si el caracter ingresado es alfanumérico
			if (!alphaNumericRegex.test(e.key)) {
				e.preventDefault()
			}
		}

		if (onKeyDown) {
			onKeyDown(e)
		}
	}

	return (
		<div className={`a-input-group ${hasError ? 'error ' : ''}${clases || ''}`}>
			{label && (
				<label className={labelClasses} htmlFor={id}>
					{label} {required ? <span style={{ color: '#ee2b7b', fontWeight: 'bold' }}>*</span> : ''}
				</label>
			)}

			<input
				data-testid={testid}
				className={inputClasses}
				id={id}
				autoComplete={autoComplete ? 'on' : 'off'}
				onChange={e => {
					if (register && typeof register !== 'function' && register.onChange) register.onChange(e)
					if (change) change(e)
				}}
				ref={register ? (typeof register === 'function' ? register : register.ref) : null}
				onKeyDown={handleKeyDown} // Reemplazado por la nueva función
				placeholder={placeholder}
				name={name || (register ? register.name : undefined)}
				value={value}
				type={type}
				onBlur={e => {
					if (register && typeof register !== 'function' && register.onBlur) register.onBlur(e)
					disableFocus(e)
					if (blurEvent) {
						blurEvent()
					}
				}}
				onFocus={activateField}
				min={min}
				max={max}
			/>

			{type === 'range' && (
				<div className='a-input__range'>
					<span className='a-input__mark' style={{ width: `${value}%` }} />
				</div>
			)}

			{hasError && <span className='a-input-error'>{errors[name].message}</span>}
		</div>
	)
}

export default Input
